import React from 'react';
import { IChangePassword, ICreateBudget } from '../../@types';
import { BankCredential, BankData, PaymentCredential } from '../../types';

export const validatePaymentForm = (
  formData: PaymentCredential,
  setValidationResults: React.Dispatch<React.SetStateAction<PaymentCredential>>,
): boolean => {
  const errors = {
    paymentProvider: '',
    paymentCredentials: {
      publicKey: '',
      secretKey: '',
    },
  };
  let errorFound = false;
  if (!formData.paymentProvider) {
    errors.paymentProvider = 'payment Provider is required';
    errorFound = true;
  }
  if (!formData.paymentCredentials.publicKey) {
    errors.paymentCredentials.publicKey = 'public Key is required';
    errorFound = true;
  }
  if (!formData.paymentCredentials.secretKey) {
    errors.paymentCredentials.secretKey = 'secret Key is required';
    errorFound = true;
  }
  setValidationResults(errors);
  return errorFound;
};


export const validateBudgetForm = (
  formData: ICreateBudget,
  setValidationResults: React.Dispatch<React.SetStateAction<ICreateBudget>>,
): boolean => {
  const errors = {
    monthYear: '',
    allocatedBudget: '',
  };
  let errorFound = false;
  if (!formData.monthYear) {
    errors.monthYear = 'Month is required';
    errorFound = true;
  }
  if (!formData.allocatedBudget) {
    errors.allocatedBudget = 'Amount is required';
    errorFound = true;
  }

  setValidationResults(errors);
  return errorFound;
};


export interface ValidationError {
  bankName: string;
  accountNumber: string;
  accountName: string;
}

export const validateBankForm = (
  // formData: BankCredential,
  formData: BankData,
  setValidationResults: React.Dispatch<React.SetStateAction<ValidationError>>,
): boolean => {
  const errors: ValidationError = {
    bankName: '',
    accountNumber: '',
    accountName: '',
  };
  let errorFound = false;
  if (!formData.bankName) {
    errors.bankName = 'Bank name is required';
    errorFound = true;
  }
  if (!formData.accountNumber) {
    errors.accountNumber = 'Account number is required';
    errorFound = true;
  }
  if (!formData.accountName) {
    errors.accountName = 'Account name is required';
    errorFound = true;
  }

  setValidationResults(errors);
  return errorFound;
};


export const validateCreatePasswordForm = (formData: IChangePassword): { [key: string]: string } => {
  const errors: { [key: string]: string } = {};

  if (!formData.currentPassword) {
    errors.currentPassword = "Please enter your current password";
   }

  return errors;
};

export const validateNewPasswordForm = (newPassword: string, confirmPassword: string, oldPassword: string): { [key: string]: string } => {
  const errors: { [key: string]: string } = {};

  if (!newPassword) {
    errors.newPassword = 'Please enter your new password';
  }

  if (newPassword !== confirmPassword) {
    errors.confirmPassword = 'Passwords do not match';
  }

  if (newPassword === oldPassword) {
    errors.newPassword = 'New password must be different from the previous password';
  }

  return errors;
};